import React from "react";
import Slider from "react-slick";
import Button from '../../button/Button';
import dispatchEvent from '../../../fns/common/dispatchEvent';

import slide1 from '../../../assets/images/VIP-2.jpg';
import slide2 from '../../../assets/images/irl1.jpg';
import slide3 from '../../../assets/images/irl2.jpg';

const Join = () => {
    const sliderSettings = {
        dots: true,
        arrows: false,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        autoplay: true,
        autoplaySpeed: 2000,
        infinite: true,
    };
    return (

        <section className="join-metafans" id="join">
            <div className="container mx-auto">
                <div className="flex flex-col md:flex-row items-start">
                    <div className="w-full md:w-5/12 md:mr-5">
                        <h1 className="lt-white font-bold mb-5 mr-5">Join the MetaFans Community and Live Like a VIP</h1>
                        <h2 className="text-grey mb-4">We know how to throw a party and bring a community together. No other NFT has the IRL utility MetaFans has!</h2>
                        <Button
                            variant="Primary"
                            className=""
                            onClick={() => dispatchEvent("opensaleModalRequested")}
                        >
                            Mint a MetaFan NFT
                        </Button>
                    </div>
                    <div className="w-full md:w-7/12 utilities-vert-slider relative">
                        <Slider {...sliderSettings}>
                            <img src={slide1} alt="metafans photos"></img>
                            <img src={slide2} alt="irl metafans photos"></img>
                            <img src={slide3} alt="irl metafans photos"></img>
                        </Slider>
                    </div>
                </div>
            </div>
        </section>

    );
};

export default Join;